module.exports = __webpack_public_path__ + "img/lacoste_content_img_05.a7f26f03.jpg";